/* components/App.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import { Router, Link, Route } from "svelte-routing";
import Catalog from "./Catalog.svelte";
import User from "./User.svelte";

function create_default_slot(ctx) {
	let t;
	let current;

	const route0 = new Route({
			props: {
				path: "/zf/user/:userId",
				component: User
			}
		});

	const route1 = new Route({
			props: { path: "/zf/", component: Catalog }
		});

	return {
		c() {
			create_component(route0.$$.fragment);
			t = space();
			create_component(route1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(route0, target, anchor);
			insert(target, t, anchor);
			mount_component(route1, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(route0.$$.fragment, local);
			transition_in(route1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(route0.$$.fragment, local);
			transition_out(route1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(route0, detaching);
			if (detaching) detach(t);
			destroy_component(route1, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current;

	const router = new Router({
			props: {
				url: /*url*/ ctx[0],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			create_component(router.$$.fragment);
			attr(div, "class", "container");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(router, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const router_changes = {};
			if (dirty & /*url*/ 1) router_changes.url = /*url*/ ctx[0];

			if (dirty & /*$$scope*/ 2) {
				router_changes.$$scope = { dirty, ctx };
			}

			router.$set(router_changes);
		},
		i(local) {
			if (current) return;
			transition_in(router.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(router.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(router);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { url = "" } = $$props;

	$$self.$set = $$props => {
		if ("url" in $$props) $$invalidate(0, url = $$props.url);
	};

	return [url];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { url: 0 });
	}
}

export default App;